'use client';

import { FullStory } from './FullStory';
import { FullStoryCrossDomainSync } from './FullStoryCrossDomainSync';
import { useFlagsProxy } from '@modules/feature-flags/hooks/useFlagsProxy';

import React, { useEffect } from 'react';

export const FullStoryLoader: React.FC = () => {
  const { cloudPortalClientTelemetryCollection } = useFlagsProxy();
  const fullstoryEnabled = process.env.FULLSTORY_ENABLED === 'true';
  const shouldRecord = fullstoryEnabled && cloudPortalClientTelemetryCollection;

  useEffect(() => {
    const applyRecordingState = () => {
      if (shouldRecord) {
        window.FS?.restart?.();
      } else {
        window.FS?.shutdown?.();
      }
    };

    if (window.FS) {
      applyRecordingState();

      return;
    }

    const poll = setInterval(() => {
      if (window.FS) {
        applyRecordingState();
        clearInterval(poll);
      }
    }, 100);

    return () => clearInterval(poll);
  }, [shouldRecord]);

  if (!shouldRecord) {
    return null;
  }

  return (
    <>
      <FullStory />
      <FullStoryCrossDomainSync />
    </>
  );
};
